var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"default-layout"}},[_c('router-view'),_c('FadeTransition',[(_vm.$store.state.isFullLoading)?_c('FullLoading'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }